import { FilePlus2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NativeButton } from "@/components/common/NativeButton";

export function CvBlankDocumentState({
  onAddSections,
}: {
  onAddSections: () => void;
}) {
  const { t } = useTranslation("seeker");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 16,
        maxWidth: 480,
        margin: "32px auto 0",
        padding: "28px 24px",
        border: "1px dashed var(--tabbio-cv-border, rgba(0,0,0,0.16))",
        borderRadius: 16,
        background: "var(--tabbio-cv-surface, #f9f9f9)",
        textAlign: "center",
      }}
    >
      <FilePlus2
        size={24}
        strokeWidth={1.7}
        color="var(--tabbio-cv-text-secondary, #5d5d5d)"
        aria-hidden
      />
      <div style={{ display: "grid", gap: 6 }}>
        <h2
          style={{
            margin: 0,
            font: "inherit",
            fontSize: 18,
            fontWeight: 600,
            color: "var(--tabbio-cv-text, #0d0d0d)",
          }}
        >
          {t("cv.edit.blankPreviewTitle")}
        </h2>
        <p
          style={{
            margin: 0,
            fontSize: 14,
            lineHeight: 1.5,
            color: "var(--tabbio-cv-text-secondary, #5d5d5d)",
          }}
        >
          {t("cv.edit.blankPreviewBody")}
        </p>
      </div>
      <NativeButton
        title={t("cv.edit.addSections")}
        onPress={onAddSections}
        size="sm"
        pill
        style={{ minHeight: 40, borderRadius: 9999 }}
      />
    </div>
  );
}
